import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Global API error banner state. Surfaced by an error boundary / toast
 * sitting near the app shell. Mirrors mobile-app/src/store/error.state.ts.
 */
export type ErrorState = {
  message: string;
  status: number;
} | null;

const initialState = null as ErrorState;

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setApiError: (_state, action: PayloadAction<ErrorState>) => action.payload,
    clearApiError: () => initialState,
  },
});

export const { setApiError, clearApiError } = errorSlice.actions;
export default errorSlice.reducer;
